document.addEventListener("DOMContentLoaded", async function () {

    const names = [
        "Rahul","Priya","Anil","Sneha","Kiran","Ravi","Pooja","Arjun",
        "Neha","Suresh","Divya","Mahesh","Ramesh","Kavya","Vijay",
        "Lakshmi","Harish","Akhil","Nikhil","Meera","Swetha Alyana"
    ];

    const cities = [
        "Hyderabad","Bengaluru","Chennai","Mumbai","Pune",
        "Delhi","Vizag","Kolkata","Ahmedabad","Jaipur","Vizag"
    ];

    let products = [];

    try{
        const response = await fetch('/products.json?limit=250');
        const data = await response.json();
        products = data.products;
    }catch(e){
        console.log(e);
        return;
    }

    if(products.length === 0) return;

    const popup = document.createElement("div");
    popup.id="sales-popup";

    popup.innerHTML=`
        <img id="popup-img">
        <div class="popup-content">
            <div id="popup-title"></div>
            <div id="popup-product"></div>
            <div id="popup-time"></div>
        </div>
    `;

    document.body.appendChild(popup);

    function random(arr){
        return arr[Math.floor(Math.random()*arr.length)];
    }

    function showPopup(){

        const product=random(products);

        popup.querySelector("#popup-img").src=product.images[0]?.src || "";
        popup.querySelector("#popup-product").innerHTML=product.title;

        popup.querySelector("#popup-title").innerHTML=
            `${random(names)} from ${random(cities)} purchased`;

        popup.querySelector("#popup-time").innerHTML=
            `${Math.floor(Math.random()*59)+1} minutes ago`;

        popup.onclick=function(){
            window.location.href = '/products/' + product.handle;
        }

        popup.classList.add("show");

        setTimeout(()=>{
            popup.classList.remove("show");
        },5000);

    }

    showPopup();

    setInterval(showPopup,15000);

});